module.exports = __webpack_public_path__ + "static/media/GoogleDA-4.a444b3ca.jpg";